/**
 * Creator reviews platform tabs.
 *
 * Was an inline <script> using document.currentScript — null on a theme-editor
 * re-render, so the tabs went dead there. It also claimed role="tablist" without
 * any tabpanel, and swapped six cards with no announcement.
 */
(function () {
  if (window.__onzCreatorTabsInit) return;
  window.__onzCreatorTabsInit = true;

  function wire(root) {
    (root || document).querySelectorAll('.onz-creators').forEach(function (sec) {
      if (sec.dataset.onzTabsWired) return;
      var tabs = sec.querySelectorAll('.onz-creators__tab');
      if (!tabs.length) return;
      sec.dataset.onzTabsWired = '1';

      function select(btn) {
        sec.dataset.platform = btn.dataset.platform;
        tabs.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        var rail = sec.querySelector('.onz-creators__rail');
        if (rail) {
          var shown = rail.querySelectorAll('.onz-creators__card:not([hidden])').length;
          rail.setAttribute('aria-label', btn.textContent.trim() + ' — ' + shown + ' creators');
        }
        btn.focus();
      }

      tabs.forEach(function (btn, i) {
        btn.addEventListener('click', function () { select(btn); });
        btn.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          select(tabs[(i + d + tabs.length) % tabs.length]);
        });
        btn.tabIndex = btn.classList.contains('is-active') ? 0 : -1;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); });
  } else {
    wire();
  }
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
})();
